<template>
  <div class="card">
    <div class="card-body text-center text-muted py-5">
      <i class="fa-solid fa-scale-balanced fa-2x mb-3"></i>
      <p class="mb-0">Finance reconciliation data is not available yet (#170).</p>
      <p class="mb-0">Chargeback register, GL postings and discrepancy reports land once issue #170-A ships.</p>
    </div>
  </div>
</template>

<script setup>
// Named seam only (epic #173, issue #169 plan, "Assumptions Taken" — the deferred finance panel).
// #170-A has not landed, so there is no read model to render here yet; #169 kept the chargeback/
// reconciliation views as a follow-on rather than guessing a data shape (epic re-plan addendum §5
// item 4). This file is the one place to fill in once #170-A ships.
</script>
